export default __webpack_public_path__ + "static/media/page-title-img.f24a40c9.png";